document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.getElementById('ProductTabs');
  const spacer = document.getElementById('ProductTabsSpacer');
  const description = document.querySelector('.product-description.page-width');

  if (!tabs || !spacer) return;

  function isMobile() { return window.matchMedia('(max-width: 1180px)').matches; }
  function getHeaderHeight() {
    const announcementOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-offset')) || 0;
    if(isMobile()){
      return 60 + announcementOffset;
    } else {
      return 90;
    }
  }
  function getTabHeight() { return isMobile() ? 40 : 80; }

  let isScrollingByTabClick = false;
  let clickedTabIndex = null;

  const tabItems = document.querySelectorAll('.product-tabs__nav li');
  const detailEl = document.querySelector('.product-description.page-width');
  const sizeEl = document.getElementById('tab-size');
  const reviewEl = document.querySelector('.pdp-reviews-container')?.previousElementSibling;
  const relatedEl = document.querySelector('.related-products');
  
  const sections = [
    { el: detailEl, tabIndex: 0 },
    { el: sizeEl, tabIndex: 1 },
    { el: reviewEl, tabIndex: 2 },
    { el: relatedEl, tabIndex: 3 },
  ].filter((item) => item.el);
  sections.sort((a, b) => a.el.offsetTop - b.el.offsetTop);
    
  function activateTab(index) {
    if (index === null) return;
    tabItems.forEach((li) => li.classList.remove('is-active'));

    const targetMap = ['tab-detail', 'tab-size', 'tab-review', 'tab-related'];
    const targetId = targetMap[index];

    tabItems.forEach((li) => {
      const link = li.querySelector('a');
      if (link && link.getAttribute('data-tab-target') === targetId) {
        li.classList.add('is-active');
      }
    });
  } 


  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    const H_HEIGHT = getHeaderHeight();
    const T_HEIGHT = getTabHeight();

    const startY = spacer.offsetTop - H_HEIGHT;
    const isFixed = tabs.classList.contains('is-fixed');
    const threshold = isFixed ? startY : startY - T_HEIGHT;

    if (scrollY >= threshold) {
      if (!isFixed) {
        tabs.classList.add('is-fixed');
        spacer.style.height = T_HEIGHT + 'px';
        if (description) description.style.marginTop = '0';
      }
      tabs.style.top = H_HEIGHT + 'px';
    } else {
      if (isFixed) {
        tabs.classList.remove('is-fixed');
        spacer.style.height = '0px';
        tabs.style.top = '';
      }
    }

    if (isScrollingByTabClick) {
      activateTab(clickedTabIndex);
      return;
    }
    const currentY = scrollY + H_HEIGHT + (isFixed ? T_HEIGHT : 0) + 20;
    for (let i = sections.length - 1; i >= 0; i--) {
      if (currentY >= sections[i].el.offsetTop) {
        activateTab(sections[i].tabIndex);
        break;
      }
    }
  });

  // 탭 클릭 이벤트
  tabItems.forEach((tabItem) => {
    const link = tabItem.querySelector('a');
    if (!link) return;

    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = link.getAttribute('data-tab-target');

      const targetSection = sections.find(s => 
        (s.el.id === targetId) || 
        (targetId === 'tab-related' && s.el.classList.contains('related-products'))
      );
      
      const targetEl = targetSection ? targetSection.el : null;
      if (!targetEl) return;

      isScrollingByTabClick = true;
      tabItems.forEach(li => li.classList.remove('is-active'));
      tabItem.classList.add('is-active');

      const targetTop = targetEl.getBoundingClientRect().top + window.scrollY;
      const offset = getHeaderHeight() + getTabHeight();

      window.scrollTo({
        top: targetTop - offset, 
        behavior: 'smooth'
      });

      let scrollTimeout;
      const checkScroll = () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          isScrollingByTabClick = false;
          clickedTabIndex = null;
          window.removeEventListener('scroll', checkScroll);
        }, 100);
      };
      window.addEventListener('scroll', checkScroll);
    });
  });

  setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
  }, 100);
});